// =============================================================================
// 錨點連結
$(document).on('click', '.js-nav', function (event) {
    event.preventDefault();
    let delay = $(this).data('delay') ? $(this).data('delay') : 0;
    let target = $(this).attr('href') || $(this).attr('xlink:href') || $(this).data('target');
    setTimeout(() => {
        let offset = $('.page-submenu').outerHeight();
        let targetPos = $(target).offset().top;
        let finalPos = offset ? targetPos - offset : targetPos;
        window.scroll({ top: finalPos, left: 0, behavior: 'smooth' });
    }, delay);
});

$("body").attr({"data-spy": "scroll" , "data-target": ".navbar-scroll" , "data-offset":"60"});

$(window).bind('scroll resize', function(){

    const { scrollTop } = document.documentElement;
    const sectTop = $('.c2').offset().top;
    
    if( scrollTop > sectTop ){
//         $('.navbar-wrap ').css({"display" : 'none' })
         $('.header-box ').css({"display" : 'none' })
        
        }
    else{
//         $('.navbar-wrap ').css({"display" : 'block' })
          $('.header-box ').css({"display" : 'block' })
         
        }

}).scroll();